import React from 'react';
import { AppBar, GetToolBarConfig, ToolBar } from '../../../../@components/bars';
import { Game } from '../../components/Game';
import { useTranslation } from 'react-i18next';

export const GamePage = () => {
  const { t } = useTranslation();

  const toolBarConfig: GetToolBarConfig[] = [
    {
      name: 'chat',
      iconKey: 'chat',
      type: 'page',
      isNested: false,
      isNeedAuth: false,
      text: t('chat'),
    },
    {
      name: 'top',
      iconKey: 'top',
      type: 'page',
      isNested: true,
      isNeedAuth: false,
      text: t('top'),
    },
    {
      name: 'history',
      iconKey: 'history',
      type: 'page',
      isNested: true,
      isNeedAuth: false,
      text: t('history'),
    },
    {
      name: 'rules',
      iconKey: 'rules',
      type: 'page',
      isNested: true,
      isNeedAuth: false,
      text: t('rules'),
    },
  ];
  return (
    <>
      <AppBar isGame />
      <div className="content dark-layout">
        <ToolBar toolBarItemsConfig={toolBarConfig} />
        <Game />
      </div>
    </>
  );
};
